module.exports = __webpack_public_path__ + "img/base_activites_visites.82298875.svg";